// extracted by mini-css-extract-plugin
export var container = "styles-module--container--pAx6h";
export var title = "styles-module--title--pF4jP";
export var wrapper = "styles-module--wrapper--sV4R0";
export var point = "styles-module--point--O9SCt";
export var pointImage = "styles-module--point-image--LmyB1";
export var pointTitle = "styles-module--point-title--NkQaQ";
export var pointDescription = "styles-module--pointDescription--DDWSO";
export var spacerTop = "styles-module--spacer-top--L1qIX";